export const RESUME_TEMPLATES = {
  MODERN: 'modern',
  JSON_ELEGANT: 'json-elegant',
  IMPORT_CUSTOM: 'import-custom'
};

// Seniority Levels
export const SENIORITY_LEVELS = [
  'Entry Level',
  'Mid Level',
  'Senior Level',
  'Lead',
  'Manager',
  'Director',
  'VP',
  'C-Level',
  'Executive'
];

// Industries
export const INDUSTRIES = [
  'Technology',
  'Finance',
  'Healthcare',
  'Education',
  'Marketing',
  'Sales',
  'Engineering',
  'Design',
  'Product Management',
  'Operations',
  'Human Resources',
  'Legal',
  'Consulting',
  'Real Estate',
  'Retail',
  'Manufacturing',
  'Media & Entertainment',
  'Non-Profit',
  'Government',
  'Other'
];

// Default Resume Structure
export const DEFAULT_RESUME = {
  title: 'My Resume',
  headline: '',
  summary: '', // About section for profile
  professional_summary: '', // Professional Summary for profile (above work experience)
  target_role: '',
  target_industry: '',
  seniority_level: '',
  photo_url: '',
  banner_url: '',
  contact_email: '',
  contact_phone: '',
  location: '',
  linkedin_url: '',
  website_url: '',
  pronouns: '', // e.g., "He/Him", "She/Her", "They/Them"
  credentials: '', // e.g., "PMP, CSM®"
  profile_frame: '', // Profile picture frame option: 'lookingtowork', 'jobseeking', 'recruitingnow', 'seekingtalent'
  ai_score: 0,
  ai_feedback: '',
  is_primary: false,
  template: RESUME_TEMPLATES.MODERN,
  public_link_id: '',
  highlight_color: '#3b82f6', // Default blue
  core_skills: [],
  credly_badges: [],
  experience: [],
  education: [],
  training: [],
  skills: [],
  certifications: [],
  projects: [],
  languages: [],
  awards: [],
  // Content visibility settings - controls what appears on the resume
  // When hidden, content is NOT deleted, just not displayed
  hidden_content: {
    sections: {
      summary: false,
      professional_summary: false,
      experience: false,
      education: false,
      skills: false,
      certifications: false,
      projects: false,
      training: false,
      languages: false,
      awards: false,
      photo: false,
      banner: false,
      contact: false
    },
    items: {} // Individual item visibility, e.g., "experience_0": true (hidden)
  }
};

// Section Types
export const SECTION_TYPES = {
  EXPERIENCE: 'experience',
  EDUCATION: 'education',
  TRAINING: 'training',
  SKILLS: 'skills',
  CERTIFICATIONS: 'certifications',
  PROJECTS: 'projects',
  LANGUAGES: 'languages',
  AWARDS: 'awards'
};

// Highlight Color Options
export const HIGHLIGHT_COLORS = [
  { name: 'Black', value: '#000000' },
  { name: 'Blue', value: '#3b82f6' },
  { name: 'Purple', value: '#a855f7' },
  { name: 'Green', value: '#10b981' },
  { name: 'Red', value: '#ef4444' },
  { name: 'Orange', value: '#f97316' },
  { name: 'Pink', value: '#ec4899' },
  { name: 'Indigo', value: '#6366f1' },
  { name: 'Teal', value: '#14b8a6' },
  { name: 'Yellow', value: '#eab308' },
  { name: 'Cyan', value: '#06b6d4' }
];

export default {
  RESUME_TEMPLATES,
  SENIORITY_LEVELS,
  INDUSTRIES,
  DEFAULT_RESUME,
  SECTION_TYPES
};
